export const RoutesMapper = {
  LOGIN: '',
  DASHBOARD: 'dashboard',
};
